import * as yup from "yup";
import { ApplicantRole, TransportType, WeeklyOrders } from "../types";

export const alphabeticalRegex = /^[A-Za-zÀ-ÖØ-öø-ÿ\s-]+$/;
export const phoneNumberRegex = /^0\d(\s?\d{2}){4}$/;

export const frenchPhoneNumberRegex = phoneNumberRegex;

export const loginSchema = yup.object().shape({
  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champs est requis"),
  password: yup.string().min(8).required("Ce champs est requis"),
});

export const registerSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(2, "Le prénom est trop court")
    .matches(alphabeticalRegex, "Le prénom ne peut contenir que des lettres")
    .required("Ce champs est requis"),
  lastName: yup
    .string()
    .min(2, "Le nom est trop court")
    .matches(alphabeticalRegex, "Le nom ne peut contenir que des lettres")
    .required("Ce champs est requis"),
  phone: yup
    .string()
    .matches(phoneNumberRegex, "Veuillez renseigner un numéro valide")
    .required("Ce champs est requis"),
  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champs est requis"),
  password: yup
    .string()
    .min(8, "Le mot de passe doit contenir au moins 8 caractéres")
    .required("Ce champs est requis"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Les mots de passe ne concordent pas")
    .required("Ce champs est requis"),
  address: yup.object().shape({
    street: yup.string().required("Ce champs est requis"),
    zipCode: yup.string().required("Ce champs est requis"),
    city: yup.string().required("Ce champs est requis"),
    country: yup.string().required("Ce champs est requis"),
  }),
});

export const forgotPasswordSchema = yup.object().shape({
  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champs est requis"),
});

export const resetPasswordSchema = yup.object().shape({
  password: yup
    .string()
    .min(8, "Le mot de passe doit contenir au moins 8 caractéres")
    .required("Ce champs est requis"),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref("password")], "Les mots de passe ne concordent pas")
    .required("Ce champs est requis"),
});

export const restaurantRequestSchema = yup.object().shape({
  displayName: yup
    .string()
    .min(2, "Le nom est trop court")
    .required("Ce champ est requis"),

  address: yup.string().required("Ce champ est requis"),

  city: yup.string().required("Ce champ est requis"),

  weeklyOrders: yup
    .string()
    .oneOf(
      Object.values(WeeklyOrders),
      "Veuillez renseigner une valeur valide pour les commandes prévues par semaine"
    )
    .required("Ce champ est requis"),

  role: yup
    .string()
    .oneOf(
      Object.values(ApplicantRole),
      "Veuillez renseigner une valeur valide pour votre fonction"
    )
    .required("Ce champ est requis"),

  firstName: yup
    .string()
    .min(2, "Le prénom est trop court")
    .matches(alphabeticalRegex, "Le prénom ne peut contenir que des lettres")
    .required("Ce champ est requis"),

  lastName: yup
    .string()
    .min(2, "Le nom est trop court")
    .matches(alphabeticalRegex, "Le nom ne peut contenir que des lettres")
    .required("Ce champ est requis"),

  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champ est requis"),

  phone: yup
    .string()
    .matches(phoneNumberRegex, "Veuillez renseigner un numéro valide")
    .required("Ce champ est requis"),
});

export const riderRequestSchema = yup.object().shape({
  firstName: yup
    .string()
    .min(2, "Le prénom est trop court")
    .matches(alphabeticalRegex, "Le prénom ne peut contenir que des lettres")
    .required("Ce champ est requis"),

  lastName: yup
    .string()
    .min(2, "Le nom est trop court")
    .matches(alphabeticalRegex, "Le nom ne peut contenir que des lettres")
    .required("Ce champ est requis"),

  email: yup
    .string()
    .email("Veuillez renseigner un email valide")
    .required("Ce champ est requis"),

  phone: yup
    .string()
    .matches(phoneNumberRegex, "Veuillez renseigner un numéro valide")
    .required("Ce champ est requis"),

  city: yup.string().required("Ce champ est requis"),

  transportType: yup
    .string()
    .oneOf(
      Object.values(TransportType),
      "Veuillez renseigner un type de transport valide"
    )
    .required("Ce champ est requis"),
});

export const profileSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  phone: yup
    .string()
    .matches(frenchPhoneNumberRegex, "Numéro invalide")
    .required(),
});

export const passwordSchema = yup.object().shape({
  oldPassword: yup.string().required("Mot de passe actuel requis"),
  newPassword: yup
    .string()
    .min(8, "Minimum 8 caractères")
    .required("Nouveau mot de passe requis"),
  confirmNewPassword: yup
    .string()
    .oneOf([yup.ref("newPassword")], "Les mots de passe ne correspondent pas")
    .required("Confirmation requise"),
});

export const addressSchema = yup.object().shape({
  displayName: yup.string().required("Nom requis (ex: Maison)"),
  street: yup.string().required("Rue requise"),
  zipCode: yup
    .string()
    .min(5, "Code postal invalide")
    .max(5, "Code postal invalide")
    .required("Code postal requis"),
  city: yup.string().required("Ville requise"),
  country: yup.string().required("Pays requis"),
});
